require('../modules/es6.object.to-string');
require('../modules/web.dom.iterable');
require('../modules/es6.weak-map');
module.exports = require('../modules/_core').WeakMap;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/weak-map.js
// module id = 470
// module chunks = 17